import type {
  PartnerAddressV2,
  PartnerCarrierAccountV2,
  PartnerContact,
  PartnerTenant,
} from '@shipium-corp/shipium-ts-types';
import type { CarrierSettings, Contract } from '../../services/FP_FulfillmentContextService/types';
import type { HydratedContract } from '../types';
import { hydrateContract } from './hydrateContract';

export interface HydrateContractsParams {
  addressList: PartnerAddressV2[];
  carrierAccountList: PartnerCarrierAccountV2[];
  carrierSettingsList: CarrierSettings[];
  contracts: Contract[];
  contactList: PartnerContact[];
  tenants: PartnerTenant[];
}

export const hydrateContracts = ({
  contactList,
  carrierAccountList,
  contracts,
  carrierSettingsList,
  tenants,
  addressList,
}: HydrateContractsParams): HydratedContract[] => {
  const carrierSettings: Record<string, CarrierSettings> = {};
  for (const curr of carrierSettingsList) {
    carrierSettings[curr.carrierSettingsId] = curr;
  }
  const contacts: Record<string, PartnerContact> = {};
  for (const curr of contactList) {
    contacts[curr.contactId!] = curr;
  }
  const addresses: Record<string, PartnerAddressV2> = {};
  for (const curr of addressList) {
    addresses[curr.addressId!] = curr;
  }
  const carrierAccounts: Record<string, PartnerCarrierAccountV2> = {};
  for (const curr of carrierAccountList) {
    carrierAccounts[curr.carrierAccountId!] = curr;
  }
  return contracts.map((contract) =>
    hydrateContract({
      contract,
      carrierAccounts,
      carrierSettings,
      contacts,
      addresses,
      tenants,
    }),
  );
};
